import React from 'react';
import { styled } from '@elliemae/ds-system';
import { DSCircularIndeterminateIndicator } from '@elliemae/ds-circular-progress-indicator';
import { DSFormComboboxName, FORM_COMBOBOX_SLOTS } from '../../constants/index.js';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 56px;
`;
const StyledDSCircularIndeterminateIndicator = styled(DSCircularIndeterminateIndicator, {
  name: DSFormComboboxName,
  slot: FORM_COMBOBOX_SLOTS.LOADING_INDICATOR,
})``;

const LoadingContainer = ({ getOwnerProps }: { getOwnerProps: () => object }) => (
  <Wrapper id="combobox-list">
    <StyledDSCircularIndeterminateIndicator size="m" getOwnerProps={getOwnerProps} />
  </Wrapper>
);

export { LoadingContainer };
export default LoadingContainer;
